var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-whales"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.9121 2H7.08791C4.90548 2 3.12249 3.67796 3.00605 5.7907L3 6.01076V16.9892C3 19.1305 4.71024 20.8798 6.86362 20.9941L7.08791 21H16.9121C19.0945 21 20.8775 19.322 20.994 17.2093L21 16.9892V6.01076C21 3.86952 19.2898 2.12018 17.1364 2.00593L16.9121 2Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M11.4433 8.59677C11.7588 8.26583 12.2317 8.26789 12.5445 8.58348L12.6192 8.6689L16.1618 13.2562C16.2994 13.4344 16.3756 13.6656 16.3756 13.9053C16.3756 14.403 16.0541 14.8131 15.64 14.8692L15.5429 14.8757H8.45767C8.25197 14.8757 8.05355 14.787 7.90065 14.6266C7.58512 14.2957 7.53724 13.7474 7.77371 13.3517L7.83876 13.2562L11.3814 8.6689C11.4009 8.64361 11.4216 8.61953 11.4433 8.59677Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVote);
export default __webpack_public_path__ + "static/media/vote.959650d330f6ba63d3bcba19f525b450.svg";
export { ForwardRef as ReactComponent };